/*eslint-env jquery*/
import React, { Component } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { memberService } from '../../_services/member.service'
import Modal from 'react-responsive-modal'
import classStatuses from '../../_constants/classStatuses'
import classTypes from '../../_constants/classTypes'
import RegionSelectForAdmin from '../Shared/RegionSelectForAdmin'
import ClassTypesSelect from '../Shared/ClassTypesSelect'
import NumberFormat from 'react-number-format'
import { history } from '../../_helpers'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import FormikCheckbox from '../Shared/FormikCheckbox'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import PieChart from 'react-minimal-pie-chart'
import ClassSelectForAdmin from '../Shared/ClassSelectForAdmin'
import DatePicker from '../Shared/DatePicker'
import GenderSelectForAdmin from '../Shared/GenderSelectForAdmin'
import PicUploaderLiner from '../Shared/PicUploaderLiner'
import { StatusSelect } from '../Shared/StatusSelect'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

const initialValues = {
  classId: '',
  unionId: '',
  firstName: '',
  lastName: '',
  nationalCode: '',
  idNumber: '',
  fatherName: '',
  birthDate: '',
  isicCode: '',
  mobile: '',
  gender: '',
  imagePath: '',
  captcha: '',
  accept: '',
  birthPlace: '',
  address: '',
  tels: '',
  senfNumber: '',
  memberStatus: undefined,
  isIsargar: false,
  region: '',
  codePosti: '',
  codeMeliImagePath: ''
  // categories: [],

  // applicationPalnsId: undefined,
  // userName: '',
  // password: '',
}

class Class extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      initialValues: initialValues
    }
  }

  handleSubmit = values => {
    // console.log(JSON.stringify(values));

    memberService
      .addFromAdmin(JSON.stringify(values))
      .then(res => {
        // console.log(res.data);

        // this.setState({ loading: false, modal: false });
        toastr.success('ثبت نام', 'اطلاعات شرکت کننده با موفقیت ثبت شد')
        history.push('/admin/member')
      })
      .catch(error => {
        console.log(error)
      })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      classId: Yup.string()
        .trim()
        .nullable()
        .required('تقویم کلاس'),

      unionId: Yup.string()
        .trim()
        .nullable()
        .required('اتحادیه'),

      firstName: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [نام] الزامی است')
        .matches(
          /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
          {
            message: 'لطفا فقط از حروف فارسی استفاده کنید',
            excludeEmptyString: false
          }
        )
        .test('len', 'نام وارد شده نا معتبر است', val => val && val.length > 1),

      lastName: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [نام خانوادگی] الزامی است')
        .matches(
          /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
          {
            message: 'لطفا فقط از حروف فارسی استفاده کنید',
            excludeEmptyString: false
          }
        )
        .test(
          'len',
          'نام خانوادگی وارد شده نا معتبر است',
          val => val && val.length > 1
        ),

      nationalCode: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [کد ملی] الزامی است')
        .matches(/^[0-9]\d{9}$/, {
          message: 'کد ملی باید شامل 10 رقم باشد',
          excludeEmptyString: false
        }),

      idNumber: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [شماره شناسنامه] الزامی است'),

      fatherName: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [نام پدر] الزامی است')
        .matches(
          /^[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s\n\r\t\(\)\[\]\{\}.,،;\-؛]+$/,
          {
            message: 'لطفا فقط از حروف فارسی استفاده کنید',
            excludeEmptyString: false
          }
        )
        .test('len', 'نام وارد شده نا معتبر است', val => val && val.length > 1),

      birthDate: Yup.string()
        .trim()
        .nullable()
        .required('تاریخ تولد'),

      senfNumber: Yup.string()
        .trim()
        .nullable()
        .required('کد رهگیری (شناسه صنفی)'),

      mobile: Yup.string()
        .trim()
        .nullable()
        .required('وارد کردن [شماره موبایل] الزامی است')
        .matches(/(\+98|0)?9\d{9}/, {
          message: 'شماره موبایل وارد شده نامعتبر است',
          excludeEmptyString: false
        }),

      gender: Yup.string()
        .trim()
        .nullable()
        .required('انتخاب [جنسیت] الزامی است'),

      birthPlace: Yup.string()
        .trim()
        .nullable()
        .required('محل صدور'),

      address: Yup.string()
        .trim()
        .nullable()
        .required('نشانی واحد صنفی'),

      tels: Yup.string()
        .trim()
        .nullable()
        .required('تلن ثابت'),

      region: Yup.string()
        .trim()
        .nullable()
        .required('انتخاب [منطقه شهرداری] الزامی است'),

      codePosti: Yup.string()
        .trim()
        .nullable()
        .required('کدپستی')
        .test(
          'len',
          'کدپستی وارد شده نا معتبر است',
          val => val && val.length == 10
        ),

      isicCode: Yup.string()
        .trim()
        .nullable()
        .required('کد isic'),

      memberStatus: Yup.string()
        .trim()
        .nullable()
        .required('وضعیت شرکت کننده'),

      // imagePath: Yup.string().trim().nullable()
      //   .required('بارگزاری [تصویر] الزامی است'),

      codeMeliImagePath: Yup.string()
        .trim()
        .nullable()
        .required('بارگزاری [تصویر کارت ملی] الزامی است')
    })
    const { initialValues, loading, data } = this.state
    return (
      <div className="row table-container" style={{ marginTop: 0 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            this.handleSubmit(values)
            setSubmitting(false)
          }}
          validationSchema={ValidationSchema}>
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit
            } = props
            return (
              <div className="row" style={{ position: 'relative' }}>
                <div className="col-md-12">
                  <form onSubmit={handleSubmit}>
                    <Tabs
                      transition={false}
                      id="controlled-tab-example"
                      activeKey={this.state.key}
                      onSelect={key => this.setState({ key })}>
                      <Tab eventKey="info" title="ثبت کاربر جدید">
                        <div className="row">
                          <div className="col-md-10 col-md-offset-1">
                            <div className="row">
                              <div
                                className={
                                  loading
                                    ? 'form-inline adminForm blur'
                                    : 'form-inline adminForm'
                                }>
                                <div className="col-md-2 text-left">
                                  <label>اتحادیه</label>
                                </div>
                                <div className="col-md-10 rtl">
                                  <UnionSelectForAdmin
                                    required
                                    defaultValue={values.unionId}
                                    onChange={val => {
                                      setFieldValue('unionId', val)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="unionId"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label>تقویم کلاس</label>
                                </div>
                                <div className="col-md-10 rtl">
                                  <ClassSelectForAdmin
                                    required
                                    defaultValue={values.classId}
                                    onChange={(id, amount) => {
                                      setFieldValue('classId', id)
                                      setFieldValue('amount', amount)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="classId"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label style={{ lineHeight: 'unset' }}>
                                    تصویر پرسنلی
                                    <br />
                                    <span
                                      style={{
                                        color: '#d8848e',
                                        fontSize: '11px',
                                        paddingLeft: 15
                                      }}>
                                      ابعاد 3 * 4
                                    </span>
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <PicUploaderLiner
                                    label="انتخاب فایل"
                                    value={values.imagePath}
                                    onChange={val => {
                                      // console.log(val);
                                      setFieldValue('imagePath', val)
                                    }}
                                  />
                                  {getIn(errors, 'imagePath') &&
                                  getIn(touched, 'imagePath') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.imagePath}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>جنسیت</label>
                                </div>
                                <div className="col-md-4 rtl">
                                  <GenderSelectForAdmin
                                    required
                                    defaultValue={values.gender}
                                    onChange={val => {
                                      setFieldValue('gender', val)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="gender"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label>نام</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.firstName}
                                    onBlur={handleBlur}
                                    name="firstName"
                                    touched={touched.firstName}
                                    className={
                                      getIn(errors, 'firstName') &&
                                      getIn(touched, 'firstName')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  {getIn(errors, 'firstName') &&
                                  getIn(touched, 'firstName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.firstName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>نام خانوادگی</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.lastName}
                                    onBlur={handleBlur}
                                    name="lastName"
                                    touched={touched.lastName}
                                    className={
                                      getIn(errors, 'lastName') &&
                                      getIn(touched, 'lastName')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  {getIn(errors, 'lastName') &&
                                  getIn(touched, 'lastName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.lastName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label>کد ملی</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    format="##########"
                                    isNumericString
                                    allowNegative={false}
                                    name="nationalCode"
                                    onChange={e => {
                                      setFieldValue(
                                        'nationalCode',
                                        e.target.value
                                      )
                                    }}
                                    onBlur={handleBlur}
                                    value={values.nationalCode}
                                    className={
                                      errors.nationalCode &&
                                      touched.nationalCode
                                        ? 'text-input numberFa rtl has-error'
                                        : 'text-input numberFa rtl required'
                                    }
                                  />

                                  {getIn(errors, 'nationalCode') &&
                                  getIn(touched, 'nationalCode') ? (
                                    <div
                                      className={'required_validator visible '}>
                                      <div className="validator_container">
                                        <span>{errors.nationalCode}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>شماره شناسنامه</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    isNumericString
                                    allowNegative={false}
                                    name="idNumber"
                                    onChange={e => {
                                      setFieldValue('idNumber', e.target.value)
                                    }}
                                    onBlur={handleBlur}
                                    value={values.idNumber}
                                    className={
                                      errors.idNumber && touched.idNumber
                                        ? 'text-input numberFa rtl has-error'
                                        : 'text-input numberFa rtl required'
                                    }
                                  />

                                  {getIn(errors, 'idNumber') &&
                                  getIn(touched, 'idNumber') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.idNumber}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label style={{ lineHeight: 'unset' }}>
                                    تصویر کارت ملی
                                    {/* <br /><span style={{ color: '#d8848e', fontSize: '11px', paddingLeft: 15 }}>ابعاد 3 * 4</span> */}
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <PicUploaderLiner
                                    label="انتخاب فایل تصویر کارت ملی"
                                    value={values.codeMeliImagePath}
                                    onChange={val => {
                                      // console.log(val);
                                      setFieldValue('codeMeliImagePath', val)
                                    }}
                                  />
                                  {getIn(errors, 'codeMeliImagePath') &&
                                  getIn(touched, 'codeMeliImagePath') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.codeMeliImagePath}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>نام پدر</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.fatherName}
                                    onBlur={handleBlur}
                                    name="fatherName"
                                    touched={touched.fatherName}
                                    className={
                                      getIn(errors, 'fatherName') &&
                                      getIn(touched, 'fatherName')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  {getIn(errors, 'fatherName') &&
                                  getIn(touched, 'fatherName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.fatherName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label>تاریخ تولد</label>
                                </div>
                                <div className="col-md-4">
                                  <DatePicker
                                    name="expireDate"
                                    // maxDate={moment()}
                                    defaultValue={values.birthDate}
                                    required
                                    onChange={val => {
                                      setFieldValue('birthDate', val)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="birthDate"
                                  />
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>صادره از</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.birthPlace}
                                    onBlur={handleBlur}
                                    name="birthPlace"
                                    touched={touched.birthPlace}
                                    className={
                                      getIn(errors, 'birthPlace') &&
                                      getIn(touched, 'birthPlace')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="birthPlace"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label>شماره موبایل</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    isNumericString
                                    allowNegative={false}
                                    format="###########"
                                    defaultValue={values.mobile}
                                    name="mobile"
                                    onChange={e => {
                                      setFieldValue('mobile', e.target.value)
                                    }}
                                    onBlur={handleBlur}
                                    className={
                                      getIn(errors, 'mobile') &&
                                      getIn(touched, 'mobile')
                                        ? 'text-input numberFa has-error rtl'
                                        : 'text-input numberFa required rtl'
                                    }
                                  />
                                  {getIn(errors, 'mobile') &&
                                  getIn(touched, 'mobile') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.mobile}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2">
                                  <label>تلفن ثابت</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.tels}
                                    onBlur={handleBlur}
                                    name="tels"
                                    touched={touched.tels}
                                    className={
                                      getIn(errors, 'tels') &&
                                      getIn(touched, 'tels')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="tels"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label style={{ lineHeight: 'unset' }}>
                                    کد رهگیری
                                    <br />
                                    <span
                                      style={{
                                        fontSize: '11px',
                                        paddingLeft: 2
                                      }}>
                                      شناسه صنفی
                                    </span>
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.senfNumber}
                                    onBlur={handleBlur}
                                    name="senfNumber"
                                    touched={touched.senfNumber}
                                    className={
                                      getIn(errors, 'senfNumber') &&
                                      getIn(touched, 'senfNumber')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="senfNumber"
                                  />
                                </div>

                                <div className="col-md-2 text-left">
                                  <label
                                    style={{
                                      direction: 'rtl',
                                      textAlign: 'left'
                                    }}>
                                    کد isic
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    value={values.isicCode}
                                    onBlur={handleBlur}
                                    name="isicCode"
                                    touched={touched.isicCode}
                                    className={
                                      getIn(errors, 'isicCode') &&
                                      getIn(touched, 'isicCode')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="isicCode"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>منطقه شهرداری واحد صنفی</label>
                                </div>
                                <div className="col-md-4 rtl">
                                  <RegionSelectForAdmin
                                    defaultValue={values.region}
                                    onChange={val => {
                                      setFieldValue('region', val)
                                    }}
                                  />
                                  {getIn(errors, 'region') &&
                                  getIn(touched, 'region') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.region}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2">
                                  <label>کد پستی</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    isNumericString
                                    allowNegative={false}
                                    format="##########"
                                    defaultValue={values.codePosti}
                                    name="codePosti"
                                    onChange={e => {
                                      setFieldValue('codePosti', e.target.value)
                                    }}
                                    onBlur={handleBlur}
                                    className={
                                      getIn(errors, 'codePosti') &&
                                      getIn(touched, 'codePosti')
                                        ? 'text-input numberFa has-error rtl'
                                        : 'text-input numberFa required rtl'
                                    }
                                  />
                                  {getIn(errors, 'codePosti') &&
                                  getIn(touched, 'codePosti') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.codePosti}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label
                                    style={{
                                      direction: 'rtl',
                                      textAlign: 'left'
                                    }}>
                                    نشانی واحد صنفی
                                  </label>
                                </div>
                                <div className="col-md-10">
                                  <Field
                                    type="text"
                                    value={values.address}
                                    onBlur={handleBlur}
                                    name="address"
                                    touched={touched.address}
                                    className={
                                      getIn(errors, 'address') &&
                                      getIn(touched, 'address')
                                        ? 'text-input has-error rtl'
                                        : 'text-input required rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="address"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2 text-left">
                                  <label />
                                </div>
                                <div className="col-md-4 text-left">
                                  <Field
                                    component={FormikCheckbox}
                                    name="isIsargar"
                                    id="isIsargar"
                                    label={'شرکت کننده ایثار گر است'}
                                  />
                                </div>

                                <div className="col-md-2 text-left">
                                  <label>وضعیت</label>
                                </div>
                                <div className="col-md-4">
                                  <StatusSelect
                                    required
                                    defaultValue={values.memberStatus}
                                    onChange={val => {
                                      setFieldValue('memberStatus', val)
                                    }}
                                    style={{
                                      height: 40,
                                      background: '#fff',
                                      border: 'thin solid #b4b4b4',
                                      borderRadius: 7
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="memberStatus"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-12">
                                  <button
                                    type="submit"
                                    className={
                                      'icon button submit-btn ' +
                                      (isSubmitting ? 'isSubmitting' : '')
                                    }
                                    disabled={isSubmitting}>
                                    ثبت نام
                                  </button>
                                </div>
                                <div className="clearfix" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </form>
                </div>
              </div>
            )
          }}
        </Formik>
      </div>
    )
  }
}

export default Class
